import { STATUS } from 'react-joyride';
import isLocalStorageNameSupported from 'buyside/util/isLocalStorageNameSupported';

export const optOutJoyride = (status: string, cookieName: string): void => {
  if (status === STATUS.SKIPPED && isLocalStorageNameSupported()) {
    window.localStorage.setItem(cookieName, 'true');
  }
};

export const shouldHideJoyride = (cookieName: string): boolean => {
  return window.localStorage.getItem(cookieName) === 'true';
};
